import { Component, h } from 'preact';
import { FinText } from '../../../i18n';
import { Properties } from '../../../common';
import { BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import Notification, { Severity } from '../Notification/Notification';

interface StoreProps {
  open: boolean;
  countryCode: string;
}

type EffectiveProps = Properties & StoreProps & WithStyles;

const mapStateToProps = ({
  selection: { locations, activeLocationIndex },
  ux: {
    i18n: { localizations },
  },
}: BookingState): StoreProps => ({
  open: !!localizations.dynamicNotifications?.destination?.[locations[activeLocationIndex]?.destination?.countryCode],
  countryCode: locations[activeLocationIndex]?.destination?.countryCode,
});

@withStyles()
@connectStore({ mapStateToProps })
export default class DestinationNotification extends Component<Properties> {
  render({ open, countryCode }: EffectiveProps): h.JSX.Element {
    return (
      <Notification open={open} severity={Severity.INFO}>
        {open && <FinText id={`dynamicNotifications.destination.${countryCode}`} />}
      </Notification>
    );
  }
}
